import styled from 'styled-components';

import {commonPalette} from 'styles/palette';

export const StepCheckWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${commonPalette.white};
  position: relative;
`;
